import { useTranslation } from 'react-i18next';
import GenerateOfficeDoctorAttendingAccountingForm from '@/components/forms/generate-office-doctor-attending-accounting-form/generate-office-doctor-attending-accounting-form';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useGenerateOfficeDoctorAttendingAccountingModalViewModel } from './generate-office-doctor-attending-accounting-modal.viewmodel';

export const GenerateOfficeDoctorAttendingAccountingModal = () => {
  const { t } = useTranslation();
  const viewModel = useGenerateOfficeDoctorAttendingAccountingModalViewModel();

  return (
    <Dialog
      open={true}
      onOpenChange={(open) => {
        if (!open) viewModel.api.close();
      }}
    >
      <DialogContent
        className="sm:max-w-2xl"
        showCloseButton={false}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>
            {t('generate-office-doctor-attending-accounting-modal.title')}
          </DialogTitle>
          <DialogDescription>
            {t('generate-office-doctor-attending-accounting-modal.description')}
          </DialogDescription>
        </DialogHeader>

        <GenerateOfficeDoctorAttendingAccountingForm form={viewModel.form} />

        <DialogFooter>
          <Button
            variant="secondary"
            onClick={viewModel.api.cancel}
          >
            {t('btn.cancel')}
          </Button>

          <Button
            onClick={viewModel.api.submit}
            loading={viewModel.data.saving}
          >
            {t('btn.generate')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
